import { useEffect, useState } from "react";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_TRANSLATION_API_BASE_URL;


export default function DictionaryViewer({selectedProduct}) {
  const [dict, setDict] = useState(null);

  useEffect(() => {
    axios.get(`${API_BASE_URL}dictionaries/${selectedProduct}`).then(res => setDict(res.data));
  }, []);

  if (!dict) return null;

  return (
    <div className="border p-4 rounded shadow bg-gray-50">
      <h2 className="text-xl font-semibold mb-2">📚 Live Dictionaries</h2>
      <div className="space-y-2">
        <div><strong>Wrong Map:</strong> {JSON.stringify(dict.wrong_map)}</div>
        <div><strong>Too Complex:</strong> {dict.too_complex.join(", ")}</div>
        <div><strong>Glossary:</strong> {dict.glossary.join(", ")}</div>
        <div><strong>Gender Map:</strong> {JSON.stringify(dict.gender_map)}</div>
      </div>
    </div>
  );
}
